import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f21e8a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-left" }, null, -1))
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "container-fluid height--100 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_activity_loader = _resolveComponent("activity-loader")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["container-fluid activity", _ctx.notScrollable ? 'overflow-y--hidden' : ''])
  }, [
    _createElementVNode("header", _hoisted_1, [
      (_ctx.backArrowLink)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            to: _ctx.backArrowLink,
            class: "activity__back-arrow",
            "data-test": "link-backArrowLeft",
            ghost: "",
            disabled: !_ctx.backArrowLink
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["to", "disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("h1", {
        class: _normalizeClass([[{ 'ml-2 mr-3': _ctx.backArrowLink, 'activity__header--fill-space': _ctx.headerFlex }], "overflow-x--ellipsis"]),
        "data-test": "header-activityHeader",
        title: _ctx.header
      }, _toDisplayString(_ctx.header), 11, _hoisted_3),
      _renderSlot(_ctx.$slots, "additionalContent", {}, undefined, true)
    ]),
    _createElementVNode("section", {
      class: _normalizeClass(["activity__main", [{ 'activity__main--not-scrollable': _ctx.notScrollable, 'p-0': _ctx.fillMaxWorkspace }]])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 2),
    (_ctx.isActivityLoading)
      ? (_openBlock(), _createBlock(_component_activity_loader, {
          key: 0,
          "data-test": "activity-loader"
        }))
      : _createCommentVNode("", true)
  ], 2))
}